export default __webpack_public_path__ + "static/media/episode1.fe4274c3.png";